import * as React from "react";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Stack, Tooltip, Typography, IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
export default function OceanMileStone({
  onclose,
  subscriptionFormData,
  milestoneList,
  setSubscriptionFormData,
}: any) {
  const handleSwitch = (
    event: React.SyntheticEvent,
    mileStone: any,
    mileStoneId: string
  ) => {
    const { checked }: any = event.target;
    setSubscriptionFormData((prev: any) => {
      let mileStoneArray =
        prev.mileStoneType === "whatsApp"
          ? [...prev.whatsAppMilestones]
          : prev.mileStoneType === "whatsappGroup"
          ? [...prev.whatsappGroupMilestones]
          : ([...prev.emailMilestones] as any);
      if (checked) {
        mileStoneArray = [...mileStoneArray, mileStone._id];
      } else {
        mileStoneArray = mileStoneArray.filter((id: any) => id !== mileStoneId);
      }

      return {
        ...prev,
        [`${prev.mileStoneType}Milestones`]: mileStoneArray,
      };
    });
  };

  const onSelectAllMileStone = (e: React.SyntheticEvent) => {
    setSubscriptionFormData((prev: any) => {
      const { checked }: any = e.target;
      let mileStoneArray = [];
      if (checked) {
        mileStoneArray = prev?.milestoneList
          ?.filter((item: any) => !item.isAchived)
          .map((item: { _id: any }) => item?._id);
      } else {
        mileStoneArray = [];
      }

      return {
        ...prev,
        [`${prev.mileStoneType}Milestones`]: mileStoneArray,
      };
    });
  };
  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2} mb={4}>
        <Tooltip title="Go Back">
          <IconButton className="arrowBackIcon" onClick={onclose}>
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Typography className="flex gap-2 items-center" variant="body2" color="textSecondary">
          Include/Exclude milestone <ArrowUpwardIcon className="arrowUpwardIcon" />
        </Typography>
      </Stack>
      <FormControl component="fieldset">
        <FormGroup aria-label="position">
          <FormControlLabel
            value="top"
            control={
              <Switch
              className="thinSwitch"
                onChange={(e) => onSelectAllMileStone(e)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "black",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "black",
                  },
                }}
              />
            }
            checked={
              subscriptionFormData.mileStoneType === "whatsApp"
                ? subscriptionFormData.whatsAppMilestones.length ===
                  milestoneList.length
                : subscriptionFormData.mileStoneType === "whatsappGroup"
                ? subscriptionFormData.whatsappGroupMilestones.length ===
                  milestoneList.length
                : subscriptionFormData.emailMilestones.length ===
                  milestoneList.length
            }
            label="Add all"
            labelPlacement="end"
            sx={{ marginRight: 10, gap: 1 }}
          />
          {milestoneList?.map((milestone: any, index: number) => (
            <FormControlLabel
              value="top"
              key={milestone._id}
              disabled={milestone.isAchived}
              control={
                <Switch
                className="thinSwitch"
                  key={milestone._id}
                  checked={
                    subscriptionFormData.mileStoneType === "whatsApp"
                      ? subscriptionFormData.whatsAppMilestones.includes(
                          milestone._id
                        )
                      : subscriptionFormData.mileStoneType === "whatsappGroup"
                      ? subscriptionFormData.whatsappGroupMilestones.includes(
                          milestone._id
                        )
                      : subscriptionFormData.emailMilestones.includes(
                          milestone._id
                        )
                  }
                  onChange={(e) => handleSwitch(e, milestone, milestone?._id)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "black",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "black",
                    },
                  }}
                />
              }
              label={milestone?.label}
              labelPlacement="end"
              sx={{ marginLeft: 10, gap: 6 }}
            />
          ))}
        </FormGroup>
      </FormControl>
    </>
  );
}
